
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-08-16-r3f-instances",
      function () {
        return require("private-next-pages/blogs/2025-08-16-r3f-instances/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-08-16-r3f-instances"])
      });
    }
  